/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { BiLoaderAlt } from "react-icons/bi";
import { trackingJourney } from "../../../../stores/actions/tracking.actions.types";
import MetaHead from "../../../Common/Metahead";
import {
  MdOutlineShoppingCart,
  MdOutlineRemoveShoppingCart,
  MdOutlineCheckCircle,
  MdOutlinePageview,
  MdOutlineSearch,
  MdOutlineAdsClick,
  MdOutlineUpdate,
} from "react-icons/md";
import { BsBoxSeam } from "react-icons/bs";

const eventConfig = {
  page_view: {
    label: "Page View",
    icon: <MdOutlinePageview size={16} />,
    badge: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300",
    dot: "bg-blue-500",
  },
  product_view: {
    label: "Product View",
    icon: <BsBoxSeam size={14} />,
    badge:
      "bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300",
    dot: "bg-purple-500",
  },
  add_to_cart: {
    label: "Add to Cart",
    icon: <MdOutlineShoppingCart size={16} />,
    badge: "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300",
    dot: "bg-green-500",
  },
  remove_from_cart: {
    label: "Remove from Cart",
    icon: <MdOutlineRemoveShoppingCart size={16} />,
    badge: "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300",
    dot: "bg-red-500",
  },
  update_cart: {
    label: "Update Cart",
    icon: <MdOutlineUpdate size={16} />,
    badge:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300",
    dot: "bg-yellow-500",
  },
  search: {
    label: "Search",
    icon: <MdOutlineSearch size={16} />,
    badge: "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300",
    dot: "bg-gray-400",
  },
  click: {
    label: "Click",
    icon: <MdOutlineAdsClick size={16} />,
    badge:
      "bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300",
    dot: "bg-orange-500",
  },
  checkout_complete: {
    label: "Checkout Complete",
    icon: <MdOutlineCheckCircle size={16} />,
    badge:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300",
    dot: "bg-emerald-500",
  },
};

const renderYMM = (ymm) => {
  const fields = [
    "year",
    "make",
    "model",
    "bodyType",
    "subModel",
    "boltPattern",
    "frontRimSize",
    "rearRimSize",
  ];
  const tireSizes = ymm.tireSizes
    ? [...new Set(ymm.tireSizes.map((t) => t.front))].join(" · ")
    : null;

  return (
    <div className='flex flex-col gap-1'>
      <span className='text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider font-medium'>
        YMM Data
      </span>
      <div className='rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 overflow-hidden text-xs'>
        <div className='px-2 py-1.5 flex flex-wrap gap-1'>
          {fields.map((key) =>
            ymm[key] ? (
              <span
                key={key}
                className='inline-flex items-center gap-1 rounded bg-gray-100 dark:bg-gray-600 border border-gray-200 dark:border-gray-500 px-1.5 py-0.5'
              >
                <span className='text-gray-500 dark:text-gray-300 capitalize text-[10px]'>
                  {key.replace(/([A-Z])/g, " $1").trim()} :
                </span>
                <span className='font-medium text-gray-800 dark:text-gray-100'>
                  {ymm[key]}
                </span>
              </span>
            ) : null,
          )}
          {tireSizes && (
            <span className='inline-flex items-center gap-1 rounded bg-gray-100 dark:bg-gray-600 border border-gray-200 dark:border-gray-500 px-1.5 py-0.5'>
              <span className='text-gray-500 dark:text-gray-300 text-[10px]'>
                Tire Sizes :
              </span>
              <span className='font-medium font-mono text-gray-800 dark:text-gray-100'>
                {tireSizes}
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const renderCheckoutProducts = (products) => {
  if (!Array.isArray(products) || !products.length) return null;

  return (
    <div className='flex flex-col gap-1'>
      <span className='text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider font-medium'>
        Checkout Products ({products.length})
      </span>
      <div className='rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 overflow-hidden text-xs'>
        <div className='divide-y divide-gray-100 dark:divide-gray-600'>
          {products.map((product, index) => (
            <div
              key={index}
              className='px-2 py-1.5 flex flex-wrap items-center gap-1.5'
            >
              <span className='inline-flex items-center gap-1 rounded bg-gray-100 dark:bg-gray-600 border border-gray-200 dark:border-gray-500 px-1.5 py-0.5 max-w-[200px]'>
                <span className='text-gray-500 dark:text-gray-300 text-[10px]'>
                  Title :
                </span>
                <span className='font-mono font-medium text-gray-800 dark:text-gray-100 truncate'>
                  {product.title || product.name || "Product Name"}
                </span>
              </span>
              <span className='inline-flex items-center gap-1 rounded bg-green-50 dark:bg-green-900/30 border border-green-100 dark:border-green-800 px-1.5 py-0.5'>
                <span className='text-gray-500 dark:text-gray-300 text-[10px]'>
                  Price :
                </span>
                <span className='font-mono font-medium text-green-700 dark:text-green-400'>
                  ${product.price?.toFixed(2)}
                </span>
              </span>
              <span className='inline-flex items-center gap-1 rounded bg-blue-50 dark:bg-blue-900/30 border border-blue-100 dark:border-blue-800 px-1.5 py-0.5'>
                <span className='text-gray-500 dark:text-gray-300 text-[10px]'>
                  Qty :
                </span>
                <span className='font-mono font-medium text-blue-700 dark:text-blue-400'>
                  {product.quantity}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const renderMetadataValue = (key, val) => {
  if (key === "ymmData" && typeof val === "object") return renderYMM(val);
  if (key === "checkoutProducts" && Array.isArray(val))
    return renderCheckoutProducts(val);

  const display = typeof val === "object" ? JSON.stringify(val) : String(val);
  return (
    <span className='text-xs bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded px-2 py-0.5 text-gray-600 dark:text-gray-300'>
      <span className='font-medium'>{key}:</span> {display}
    </span>
  );
};

const Journey = (props) => {
  const [searchParams] = useSearchParams();
  const [identifier, setIdentifier] = useState("");
  const [searched, setSearched] = useState(false);
  const [journey, setJourney] = useState([]);

  const getPayload = (value) => {
    const trimmedValue = value.trim();
    return { q: trimmedValue };
  };

  const fetchJourney = (identifierVal) => {
    props.trackingJourney({
      data: getPayload(identifierVal),
      callback: (data) => {
        setSearched(true);
        if (data.success) setJourney(data.data.userJourney);
      },
    });
  };

  useEffect(() => {
    const emailFromUrl = searchParams.get("email");
    const phoneFromUrl = searchParams.get("phone");

    if (emailFromUrl) {
      setIdentifier(emailFromUrl);
      fetchJourney(emailFromUrl);
    } else if (phoneFromUrl) {
      setIdentifier(phoneFromUrl);
      fetchJourney(phoneFromUrl);
    }
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!identifier.trim()) return;
    fetchJourney(identifier);
  };

  const handleClear = () => {
    setIdentifier("");
    setSearched(false);
    setJourney([]);
  };

  const config = (type) =>
    eventConfig[type] || {
      label: type,
      icon: null,
      badge: "bg-gray-100 text-gray-600",
      dot: "bg-gray-400",
    };

  return (
    <div>
      <MetaHead title='User Journey' />

      {/* Search Bar */}
      <div className='bg-white dark:bg-boxdark rounded-[10px] border border-stroke p-6 mb-6'>
        <h2 className='text-base font-semibold text-gray-800 dark:text-white mb-1'>
          User Journey Tracker
        </h2>
        <p className='text-sm text-gray-500 dark:text-gray-400 mb-4'>
          Enter a user email or phone number to view their full activity
          timeline
        </p>
        <form onSubmit={handleSearch} className='flex gap-3'>
          <div className='relative flex items-center rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 transition-colors duration-300 px-3 py-2 flex-1 max-w-md'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-4 w-4 text-gray-400 mr-2 shrink-0'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <circle cx='11' cy='11' r='8'></circle>
              <line x1='21' y1='21' x2='16.65' y2='16.65'></line>
            </svg>
            <input
              type='text'
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder='user@example.com or +1234567890'
              className='flex-1 bg-transparent border-none outline-none text-sm text-gray-800 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500'
            />
            {identifier && (
              <button
                type='button'
                onClick={handleClear}
                className='text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 ml-2 text-xs'
              >
                ✕
              </button>
            )}
          </div>
          <button
            type='submit'
            disabled={!identifier.trim()}
            className='px-6 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors'
          >
            Search
          </button>
        </form>
      </div>

      {/* States */}
      {props.loading ? (
        <div className='flex dark:bg-boxdark bg-white rounded-[10px] border border-stroke items-center justify-center min-h-64'>
          <BiLoaderAlt className='animate-spin text-4xl text-red-600' />
        </div>
      ) : searched && journey.length === 0 ? (
        <div className='flex dark:bg-boxdark rounded-[10px] border border-stroke bg-white items-center justify-center min-h-64'>
          <div className='text-center'>
            <p className='text-4xl mb-3'>🔍</p>
            <p className='text-gray-500 dark:text-gray-400 text-sm'>
              No journey found for{" "}
              <span className='font-medium text-gray-700 dark:text-gray-300'>
                {identifier}
              </span>
            </p>
          </div>
        </div>
      ) : journey.length > 0 ? (
        <>
          {/* Summary Bar */}
          <div className='flex flex-wrap gap-3 mb-4'>
            <div className='bg-white dark:bg-boxdark border border-stroke rounded-lg px-4 py-2 text-sm'>
              <span className='text-gray-500 dark:text-gray-400'>User: </span>
              <span className='font-medium text-gray-800 dark:text-white'>
                {identifier}
              </span>
            </div>
            <div className='bg-white dark:bg-boxdark border border-stroke rounded-lg px-4 py-2 text-sm'>
              <span className='text-gray-500 dark:text-gray-400'>
                Total Events:{" "}
              </span>
              <span className='font-semibold text-red-600'>
                {journey.length}
              </span>
            </div>
            <div className='bg-white dark:bg-boxdark border border-stroke rounded-lg px-4 py-2 text-sm'>
              <span className='text-gray-500 dark:text-gray-400'>
                Sessions:{" "}
              </span>
              <span className='font-semibold text-gray-800 dark:text-white'>
                {new Set(journey.map((j) => j.sessionId)).size}
              </span>
            </div>
          </div>

          {/* Timeline */}
          <div className='bg-white dark:bg-boxdark border border-stroke rounded-[10px] p-6'>
            <div className='relative'>
              {/* Vertical line */}
              <div className='absolute left-[7px] top-2 bottom-2 w-0.5 bg-gray-200 dark:bg-gray-700' />

              <div className='flex flex-col gap-0'>
                {journey.map((item, index) => {
                  const cfg = config(item.eventType);
                  return (
                    <div key={index} className='flex gap-4 relative group'>
                      {/* Dot */}
                      <div
                        className={`w-3.5 h-3.5 rounded-full ${cfg.dot} shrink-0 mt-3.5 z-10 ring-2 ring-white dark:ring-boxdark`}
                      />

                      {/* Card */}
                      <div className='flex-1 mb-3 bg-gray-50 dark:bg-gray-800 rounded-lg px-4 py-3 border border-gray-100 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-500 transition-colors'>
                        <div className='flex flex-wrap items-center gap-2 mb-1.5'>
                          <span
                            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${cfg.badge}`}
                          >
                            {cfg.icon}
                            {cfg.label}
                          </span>
                          <span className='text-xs text-gray-400 dark:text-gray-500'>
                            {new Date(item.timestamp).toLocaleString()}
                          </span>
                        </div>

                        {item.path && (
                          <p className='text-xs text-gray-600 dark:text-gray-300 font-mono mb-1 truncate'>
                            {item.path}
                          </p>
                        )}

                        <div className='flex flex-wrap gap-3 mt-1'>
                          {item.metadata &&
                            Object.keys(item.metadata).length > 0 && (
                              <div className='flex flex-col gap-2 w-full'>
                                {Object.entries(item.metadata).map(([k, v]) => (
                                  <div key={k}>{renderMetadataValue(k, v)}</div>
                                ))}
                              </div>
                            )}
                          <span className='text-xs text-gray-400 dark:text-gray-500 font-mono'>
                            {item.sessionId.slice(0, 8)}…
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className='flex dark:bg-boxdark rounded-[10px] border border-stroke bg-white items-center justify-center min-h-64'>
          <div className='text-center'>
            <p className='text-4xl mb-3'>🗺️</p>
            <p className='text-gray-400 dark:text-gray-500 text-sm'>
              Enter an email or phone number above to view the user journey
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, { trackingJourney })(Journey);
